<template>
  <div class="about_area">
    <div class="container">
      <div class="row">
        <div class="col-xl-5 col-lg-6">
          <div class="single_about_info">
            <h3>
              来自 20 门课程的 <br />
              7000多个教程
            </h3>
            <p>
              覆盖幼儿园到初高中的STEAM学习资源，创新教学方式，以真实问题或项目驱动，引导学生经历原理运用过程、计算思维过程和数字化工具应用过程，构建知识，提升问题解决能力。鼓励
              做中学 用中学 创中学，”凸显学生的主体性。
            </p>
            <!-- 跳转到联系我们  -->
            <a href="#" class="boxed_btn" @click.prevent="goConcat"
              >了解并加入我们</a
            >
          </div>
        </div>
        <div class="col-xl-6 offset-xl-1 col-lg-6">
          <div class="about_tutorials">
            <div class="courses">
              <div class="inner_courses">
                <div class="text_info">
                  <span>20+</span>
                  <p>服务公立小学</p>
                </div>
              </div>
            </div>
            <div class="courses-blue">
              <div class="inner_courses">
                <div class="text_info">
                  <span>2000+</span>
                  <p>小时沉浸学习</p>
                </div>
              </div>
            </div>
            <div class="courses-sky">
              <div class="inner_courses">
                <div class="text_info">
                  <span>150+</span>
                  <p>原创课程主题</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  setup() {
    const router = useRouter();
    // 跳转关于我们页面
    const goConcat = () => {
      router.push("/concat");
    };
    return { goConcat };
  },
});
</script>
